// extracted by mini-css-extract-plugin
export default {"comment-footer":"CommentFooter_comment-footer__XudMC","icon":"CommentFooter_icon__NSaS4","selected":"CommentFooter_selected__vSTbV"};